import * as nav from '../components/navbar.js';
import * as footer from '../components/footer.js';
import * as svgInline from '../util/svgInline.js';
import * as anchorSmooth from '../util/anchorSmooth.js';
import * as toggle from '../util/toggle.js';
import * as rippleLinks from '../util/rippleLinks.js';

export default {
  init() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    // let vh = window.innerHeight * 0.01;
    // // Then we set the value in the --vh custom property to the root of the document
    // document.documentElement.style.setProperty('--vh', `${vh}px`);

    nav.toggleNav();
    // nav.toggleTextScroll();
    // nav.changelogoColor();
    nav.toggleGalaxyMenu();
    nav.toggleSubMenus();
    footer.enableCarousels();
    svgInline.imgToSvg();
    anchorSmooth.anchorSmooth();
    toggle.init();
    footer.replaceEmail();
    rippleLinks.rippleEvents();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js